import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthService } from '../auth.service';

@Injectable({ providedIn: 'root' })
export class SessionService {

  private timeoutId: any;

  constructor(private authService: AuthService) {}

  startAutoLogout() {
    if (!this.authService.isLoggedIn()) return;

    const loginTime = parseInt(localStorage.getItem('loginTime') || '0');
    const now = Date.now();

    //const SESSION_DURATION = 10 * 1000; // test
     const SESSION_DURATION = 4 * 60 * 60 * 1000; // prod

    const timeLeft = SESSION_DURATION - (now - loginTime);

    if (timeLeft <= 0) {
      this.logoutWithAlert();
    } else {
      this.timeoutId = setTimeout(() => {
        this.logoutWithAlert();
      }, timeLeft);
    }
  }

  logoutWithAlert() {
    Swal.fire({
      title: 'Session expirée',
      text: 'Veuillez vous reconnecter',
      icon: 'warning',
      confirmButtonText: 'OK'
    }).then(() => {
      this.authService.logout();
    });
  }
}